export const BALI = "Bali";
export const KOMODO = "Komodo";
export const CRUISE = "Cruise";
export const JAKARTA = "Jakarta";
